import clonedeep from 'lodash.clonedeep';
/**
 * Return a filtered set of items based on a filter object and object keys
 *
 * @param {Array} filters - The array of filter objects to filter the items array by
 * @param {Array} items - The items to filter
 * @returns {Array} Returns - A filtered set of data
 */
export function tabContentItems(items, currentTab) {
    // Make a clone of the items so filtering doesn't affect the main set
    let tabItems = clonedeep(items);
    // Only keep the items that matches the filter and keyword search
    tabItems = tabItems.filter(item => {
        // Return filter pass result
        const itemCode = parseInt(item.tabOptions[0].code, 10);
        return itemCode === currentTab;
    });

    return currentTab > 0 ? tabItems : items;
}

export function paginateItems(items, page, perPage) {
    const startAt = perPage * page;
    const paged = items.filter((item, index) => index >= startAt && index < startAt + perPage);
    return paged;
}
